// extracted by mini-css-extract-plugin
export default {"root":"ParamsShowModal_root__gVDoc","position":"ParamsShowModal_position__wSlyd"};